// Flat FR -> EN dictionary used by the DOM translator overlay.
// Rules:
//  - Keep exact FR strings as they appear in UI (incl. casing, accents, punctuation).
//  - Do NOT include dynamic data (names, numbers, currencies). Only UI chrome.
//  - Do NOT translate brand names (ProdPilot, ProdLink, Nexus, etc.) — not in the dict.
//  - When a FR string has multiple EN candidates, pick the most context-appropriate.
export const FR_EN = {
  // ===== Common actions & verbs =====
  'Enregistrer': 'Save',
  'Enregistrer les modifications': 'Save changes',
  'Annuler': 'Cancel',
  'Supprimer': 'Delete',
  'Modifier': 'Edit',
  'Ajouter': 'Add',
  'Créer': 'Create',
  'Nouveau': 'New',
  'Mettre à jour': 'Update',
  'Confirmer': 'Confirm',
  'Valider': 'Validate',
  'Fermer': 'Close',
  'Retour': 'Back',
  'Suivant': 'Next',
  'Précédent': 'Previous',
  'Chargement…': 'Loading…',
  'Chargement...': 'Loading...',
  'En cours...': 'Loading...',
  'Rechercher': 'Search',
  'Rechercher...': 'Search...',
  'Filtrer': 'Filter',
  'Filtres': 'Filters',
  'Actualiser': 'Refresh',
  'Exporter': 'Export',
  'Importer': 'Import',
  'Télécharger': 'Download',
  'Téléverser': 'Upload',
  'Voir': 'View',
  'Voir tout': 'View all',
  'Voir tout →': 'View all →',
  'Voir le détail': 'View details',
  'Voir plus': 'View more',
  'Dupliquer': 'Duplicate',
  'Archiver': 'Archive',
  'Désarchiver': 'Unarchive',
  'Envoyer': 'Send',
  'Renvoyer': 'Resend',
  'Oui': 'Yes',
  'Non': 'No',
  'Tous': 'All',
  'Toutes': 'All',
  'Tous les statuts': 'All statuses',
  'Aucun': 'None',
  'Aucune': 'None',
  'Choisir': 'Choose',
  'Sélectionner': 'Select',
  'Sélectionner un fichier': 'Select a file',
  'Sélectionner un client': 'Select a client',
  'Détails': 'Details',
  'Description': 'Description',
  'Commentaire': 'Comment',
  'Commentaires': 'Comments',
  'Ajouter un commentaire': 'Add a comment',
  'Note': 'Note',
  'Notes': 'Notes',
  'Options': 'Options',
  'Actions': 'Actions',
  'Statut': 'Status',
  'Priorité': 'Priority',
  'Date': 'Date',
  'Montant': 'Amount',
  'Total': 'Total',
  'Sous-total': 'Subtotal',
  'TVA': 'VAT',
  'HT': 'excl. VAT',
  'TTC': 'incl. VAT',
  'Référence': 'Reference',
  'Libellé': 'Label',
  'Quantité': 'Quantity',
  'Prix': 'Price',
  'Prix unitaire': 'Unit price',
  'Devise': 'Currency',
  'Remise': 'Discount',
  'Marge': 'Margin',
  'Coût': 'Cost',
  'Coûts': 'Costs',
  'Durée': 'Duration',
  'Catégorie': 'Category',
  'Type': 'Type',
  'Nom': 'Name',
  'Prénom': 'First name',
  'Email': 'Email',
  'Email pro': 'Business email',
  'Email professionnel': 'Business email',
  'Email de connexion': 'Login email',
  'Email reçu': 'Received email',
  'Téléphone': 'Phone',
  'Tel': 'Phone',
  'Tel client': 'Client phone',
  'Email client': 'Client email',
  'Adresse': 'Address',
  'Adresse complète': 'Full address',
  'Pays': 'Country',
  'Ville': 'City',
  'Code postal': 'Zip code',
  'Mot de passe': 'Password',
  'Rôle': 'Role',
  'Role': 'Role',
  'Actif': 'Active',
  'Inactif': 'Inactive',
  'Actifs': 'Active',
  'Inactifs': 'Inactive',
  'En ligne': 'Online',
  'EN LIGNE': 'ONLINE',
  'Hors ligne': 'Offline',
  'Activer': 'Enable',
  'Désactiver': 'Disable',
  'Révoquer': 'Revoke',
  'Suspendre': 'Suspend',
  'Approuver': 'Approve',
  'Rejeter': 'Reject',
  'Valider le compte': 'Approve account',
  'Rejeter le compte': 'Reject account',
  'En attente': 'Pending',
  'Validé': 'Approved',
  'Validée': 'Approved',
  'Approuvé': 'Approved',
  'Approuvée': 'Approved',
  'Refusé': 'Rejected',
  'Refusée': 'Rejected',
  'Rejeté': 'Rejected',
  'Terminé': 'Completed',
  'Terminée': 'Completed',
  'En cours': 'In progress',
  'À faire': 'To do',
  'En retard': 'Overdue',
  'Payé': 'Paid',
  'Payée': 'Paid',
  'Non payé': 'Unpaid',
  'Non payée': 'Unpaid',
  'À payer': 'To pay',
  'Partiellement payé': 'Partially paid',
  'Soldé': 'Settled',

  // ===== Dashboard =====
  'Tableau de bord': 'Dashboard',
  "Vue d'ensemble de l'activité ProdLink": "Overview of ProdLink's activity",
  "Vue d'ensemble": 'Overview',
  'Commandes en cours': 'Orders in progress',
  'COMMANDES EN COURS': 'ORDERS IN PROGRESS',
  'Commandes urgentes': 'Urgent orders',
  'COMMANDES URGENTES': 'URGENT ORDERS',
  'CA en cours': 'Revenue in progress',
  'CA EN COURS': 'REVENUE IN PROGRESS',
  'Marge estimée': 'Estimated margin',
  'MARGE ESTIMEE': 'ESTIMATED MARGIN',
  'Marge estimee': 'Estimated margin',
  'Paiements à venir (30j)': 'Upcoming payments (30d)',
  'PAIEMENTS À VENIR (30J)': 'UPCOMING PAYMENTS (30D)',
  'Paiements en retard': 'Overdue payments',
  'PAIEMENTS EN RETARD': 'OVERDUE PAYMENTS',
  'Sous-traitants actifs': 'Active subcontractors',
  'SOUS-TRAITANTS ACTIFS': 'ACTIVE SUBCONTRACTORS',
  'Projets bloqués': 'Blocked projects',
  'PROJETS BLOQUES': 'BLOCKED PROJECTS',
  'Projets bloques': 'Blocked projects',
  'Rentabilité': 'Profitability',
  'RENTABILITÉ': 'PROFITABILITY',
  'Rentabilite': 'Profitability',
  'Répartition statuts': 'Status breakdown',
  'RÉPARTITION STATUTS': 'STATUS BREAKDOWN',
  'Repartition statuts': 'Status breakdown',
  'Aucune activité récente': 'No recent activity',
  'Aucune donnée': 'No data',
  'Aucune livraison prévue': 'No scheduled delivery',
  'Marge moyenne': 'Average margin',
  'Chiffre d\'affaires': 'Revenue',
  'CA': 'Revenue',
  'Couts': 'Costs',

  // ===== Production =====
  'Production': 'Production',
  'Nouveau projet': 'New project',
  'Modifier le projet': 'Edit project',
  'Modifier le projet.': 'Edit project.',
  'Modifiez les informations du projet.': 'Edit project information.',
  'Renseignez les informations du nouveau projet.': 'Fill in the new project information.',
  'Nom du projet': 'Project name',
  'Nom du projet *': 'Project name *',
  'Client': 'Client',
  'Client *': 'Client *',
  'Sous-traitant': 'Subcontractor',
  'Sous-traitants': 'Subcontractors',
  'Sous-tr.': 'Sub.',
  'Commercial': 'Sales rep',
  'Commerciaux': 'Sales reps',
  'Client assigné (portail)': 'Assigned client (portal)',
  'Date de livraison': 'Delivery date',
  'Livraison': 'Delivery',
  'Montant HT': 'Amount excl. VAT',
  'Montant TTC': 'Amount incl. VAT',
  'Avancement': 'Progress',
  'Actions sous-traitant': 'Subcontractor actions',
  'Points particuliers de fabrication': 'Specific manufacturing points',
  'Saisie libre': 'Free text',
  '+ Saisie libre': '+ Free text',
  '← Liste': '← List',
  'Saisir le nom du client': 'Enter client name',
  'Auto-généré si vide': 'Auto-generated if empty',
  'Auto-genere si vide': 'Auto-generated if empty',
  'Priorite': 'Priority',
  'Normale': 'Normal',
  'Urgente': 'Urgent',
  'Basse': 'Low',
  'Haute': 'High',
  'À chiffrer': 'To quote',
  'A chiffrer': 'To quote',
  'En consultation': 'In consultation',
  'Confirmé': 'Confirmed',
  'En production': 'In production',
  'Expédié': 'Shipped',
  'Livré': 'Delivered',
  'Facturé': 'Invoiced',
  'Archivé': 'Archived',
  'Supprimer ce projet ?': 'Delete this project?',
  'Projet supprime': 'Project deleted',
  'Projet duplique': 'Project duplicated',
  'Erreur lors de la suppression': 'Error during deletion',
  'Erreur lors de la duplication': 'Error during duplication',
  'Erreur lors du chargement': 'Error during loading',

  // ===== Payments =====
  'Paiements': 'Payments',
  'Aucun paiement enregistré': 'No payment recorded',
  'Date échéance': "Due date",
  "Date d'échéance": "Due date",
  'Nouveau paiement': 'New payment',
  'Marquer comme payé': 'Mark as paid',
  'Marquer comme non payé': 'Mark as unpaid',
  'Facture': 'Invoice',
  'Factures': 'Invoices',
  'Numéro de facture': 'Invoice number',
  'Mode de paiement': 'Payment method',
  'Virement': 'Bank transfer',
  'Chèque': 'Check',
  'Carte': 'Card',
  'Espèces': 'Cash',

  // ===== Clients =====
  'Clients': 'Clients',
  'Aucun client enregistré': 'No client registered',
  'Nouveau client': 'New client',
  'Modifier le client': 'Edit client',
  'Entreprise': 'Company',
  'Nom de l\'entreprise': 'Company name',
  "Nom de l'entreprise": 'Company name',
  'Nom du contact': 'Contact name',
  'Contact': 'Contact',
  'Identifiants de connexion': 'Login credentials',
  'Dernière connexion': 'Last login',
  'Nombre de projets': 'Number of projects',

  // ===== Subcontractors =====
  'Aucun sous-traitant enregistré': 'No subcontractor registered',
  'Nouveau sous-traitant': 'New subcontractor',
  'Modifier le sous-traitant': 'Edit subcontractor',
  'Spécialités': 'Specialties',
  'Spécialité': 'Specialty',
  'Qualité': 'Quality',
  'Fiabilité': 'Reliability',
  'Délais': 'Lead times',
  'Score qualité': 'Quality score',
  'Note moyenne': 'Average rating',
  'Nombre de projets terminés': 'Number of completed projects',

  // ===== Commercials =====
  'Commissions dues': 'Commissions due',
  'Commissions payées': 'Commissions paid',
  'Taux de commission': 'Commission rate',
  'Nouveau commercial': 'New sales rep',
  'Modifier le commercial': 'Edit sales rep',

  // ===== Shipments =====
  'Expéditions': 'Shipments',
  'Expédition': 'Shipment',
  'Aucune expédition': 'No shipment',
  'Nouvelle expédition': 'New shipment',
  'Transporteur': 'Carrier',
  'Numéro de suivi': 'Tracking number',
  'Suivre le colis': 'Track package',
  'Date d\'expédition': 'Shipping date',
  "Date d'expédition": 'Shipping date',

  // ===== Price requests / RFQs =====
  'Demandes de prix': 'Price requests',
  'Demande de prix': 'Price request',
  'Nouvelle demande': 'New request',
  'Nouvelle demande de prix': 'New price request',
  'Analyser': 'Analyze',
  'Aucune offre reçue': 'No offer received',
  'Autre fournisseur retenu': 'Other supplier selected',
  'Autres spécifications': 'Other specifications',
  'Aucun sous-traitant ne correspond aux filtres': 'No subcontractor matches the filters',
  'Offre': 'Offer',
  'Offres': 'Offers',
  'Offres reçues': 'Offers received',
  'Envoyer la demande': 'Send request',
  'Spécifications': 'Specifications',
  'Cahier des charges': 'Specifications',
  'Plans': 'Drawings',
  'Pièces jointes': 'Attachments',
  'Pièce jointe': 'Attachment',
  'Aucune pièce jointe': 'No attachment',
  'Date limite': 'Deadline',
  'Date de réponse': 'Response date',
  'Date de clôture': 'Closing date',
  'Clôturé': 'Closed',
  'Clôturée': 'Closed',

  // ===== Quality =====
  'Problème signalé': 'Issue reported',
  'Problèmes ouverts': 'Open issues',
  'Problèmes': 'Issues',
  'Résolus': 'Resolved',
  'Résolu': 'Resolved',
  'Aucune photo': 'No photo',
  'Ouvert': 'Open',
  'Ouverte': 'Open',
  'Signaler un problème': 'Report an issue',
  'Problème qualité': 'Quality issue',
  'Résoudre': 'Resolve',

  // ===== Admin Quotes =====
  'Devis': 'Quotes',
  'Devis client': 'Client quotes',
  'Nouveau devis': 'New quote',
  'Lignes du devis': 'Quote lines',
  'Ligne': 'Line',
  'Lignes': 'Lines',
  'Contrôlez le rendu avant validation': 'Check the preview before validation',
  'Sauvegarder le client pour réutilisation': 'Save client for reuse',
  'Aperçu PDF': 'PDF preview',
  'Générer le PDF': 'Generate PDF',
  'Télécharger le PDF': 'Download PDF',

  // ===== AI Agent =====
  'Agent IA': 'AI Agent',
  'Activité': 'Activity',
  'Ajouter une entreprise': 'Add a company',
  'Clients gagnés': 'Clients won',
  'Aucune relance en attente': 'No pending follow-up',
  'Actions max': 'Max actions',
  "Cadence d'envoi": 'Sending cadence',
  'Carte des prospects actifs': 'Map of active prospects',
  'Commercial dynamique': 'Dynamic sales rep',
  'Aucun prospect': 'No prospect',
  'Amical': 'Friendly',
  'Prospect': 'Prospect',
  'Prospects': 'Prospects',
  'Relance': 'Follow-up',
  'Relances': 'Follow-ups',
  'Pas intéressé': 'Not interested',
  'Intéressé': 'Interested',

  // ===== Mileage =====
  'Frais km': 'Mileage',
  'Frais kilométriques': 'Mileage expenses',
  'Nouveau trajet': 'New trip',
  'Trajet': 'Trip',
  'Trajets': 'Trips',
  'Distance': 'Distance',
  'Départ': 'Departure',
  'Arrivée': 'Arrival',
  'Motif': 'Reason',
  'Taux km': 'Per km rate',

  // ===== Mail =====
  'Mails': 'Mail',
  "Gmail n'est pas encore connecté": 'Gmail not connected yet',
  'Connecter Gmail': 'Connect Gmail',
  'Déconnecter Gmail': 'Disconnect Gmail',
  'Corps du message': 'Message body',
  'Objet': 'Subject',
  'Destinataire': 'Recipient',
  'Destinataires': 'Recipients',
  'Expéditeur': 'Sender',

  // ===== Tickets =====
  'Tickets': 'Tickets',
  'Aucun ticket pour le moment': 'No tickets for now',
  'Réponse admin': 'Admin reply',
  'Titre': 'Title',
  'Tous statuts': 'All statuses',
  'Nouveau ticket': 'New ticket',
  'Fermer le ticket': 'Close ticket',
  'Rouvrir le ticket': 'Reopen ticket',

  // ===== To-Do =====
  'To-Do List': 'To-Do List',
  'Détail de la tâche': 'Task details',
  'Tâche': 'Task',
  'Tâches': 'Tasks',
  'Nouvelle tâche': 'New task',
  'Aucun commentaire': 'No comment',

  // ===== Settings =====
  'Paramètres': 'Settings',
  'Préférences': 'Preferences',
  'Compte': 'Account',
  'Sécurité': 'Security',
  'Changer le mot de passe': 'Change password',
  'Ancien mot de passe': 'Current password',
  'Nouveau mot de passe': 'New password',
  'Confirmer le mot de passe': 'Confirm password',
  'Utilisateurs': 'Users',
  'Gestion des utilisateurs': 'User management',
  'Ajouter un utilisateur': 'Add a user',

  // ===== 3D Printing =====
  'Impression 3D': '3D Printing',
  "Bon d'envoi": 'Shipping label',
  'Classement plateformes': 'Platform ranking',
  'Facturation': 'Billing',
  'Article': 'Item',
  'Articles': 'Items',
  'Plateforme': 'Platform',
  'Vendeur': 'Seller',
  'Acheteur': 'Buyer',

  // ===== Messages / Chat =====
  'Messages': 'Messages',
  'Message': 'Message',
  'Écrire un message...': 'Write a message...',
  "Écrire un message…": 'Write a message…',
  'Envoyer un message': 'Send a message',
  'Nouvelle conversation': 'New conversation',
  'Aucun message': 'No messages',
  'Aucune conversation': 'No conversation',

  // ===== Notifications =====
  'Notifications': 'Notifications',
  'Aucune notification': 'No notifications',
  'Tout marquer comme lu': 'Mark all as read',
  'Marquer comme lu': 'Mark as read',
  'Marquer comme non lu': 'Mark as unread',

  // ===== Common misc =====
  'Déconnexion': 'Log out',
  'Deconnexion': 'Log out',
  'Se déconnecter': 'Log out',
  'Connexion': 'Sign in',
  'Se connecter': 'Sign in',
  'Bienvenue': 'Welcome',
  'Politique de confidentialité': 'Privacy policy',
  'Mentions légales': 'Legal notice',
  "Conditions d'utilisation": 'Terms of use',
  'Erreur': 'Error',
  'Succès': 'Success',
  'Attention': 'Warning',
  'Information': 'Information',
  "Une erreur est survenue": 'An error occurred',
  'Opération réussie': 'Operation successful',
  'Non disponible': 'Not available',
  'N/A': 'N/A',
  'Divers': 'Misc',
  'Historique': 'History',
  'Journal': 'Log',
  'Dernière mise à jour': 'Last update',
  'Créé le': 'Created on',
  'Modifié le': 'Modified on',
  'Créé par': 'Created by',
  'Modifié par': 'Modified by',
  'Jour': 'Day',
  'Jours': 'Days',
  'Semaine': 'Week',
  'Semaines': 'Weeks',
  'Mois': 'Month',
  'Année': 'Year',
  'Années': 'Years',
  'Aujourd\'hui': 'Today',
  "Aujourd'hui": 'Today',
  'Hier': 'Yesterday',
  'Demain': 'Tomorrow',
  'Cette semaine': 'This week',
  'Ce mois-ci': 'This month',
  'Ce mois': 'This month',
  'Cette année': 'This year',
  'Il y a': 'Ago',
  'Dans': 'In',
  'À partir de': 'From',
  'Jusqu\'au': 'Until',
  "Jusqu'au": 'Until',
  'De': 'From',
  'À': 'To',
  'Et': 'And',
  'Ou': 'Or',
  'Par': 'By',
  'Pour': 'For',
  'Avec': 'With',
  'Sans': 'Without',
  // ===== Runtime misses =====
  'Annulé': 'Cancelled',
  'Bloqué': 'Blocked',
  'Contrôle qualité': 'Quality control',
  'Devis envoyé': 'Quote sent',
  'Devis prêt': 'Quote ready',
  'Gagné': 'Won',
  'Payé partiellement': 'Partially paid',
  'Prêt à expédier': 'Ready to ship',
  'Relancé': 'Followed up',
  'Relance à faire': 'Follow-up needed',
  'À venir': 'Upcoming',
  'Virement, cheque...': 'Bank transfer, cheque...',
  'Employé': 'Employee',
  '{x} tâche': '{x} task(s)',
  '{x} tâches': '{x} tasks',
  '% sur marge nette': '% of net margin',
  'Aéronautique': 'Aerospace',
  'Commande lancée': 'Order launched',
  'Création projet': 'Project created',
  'Mise à jour projet': 'Project updated',
  'Emails envoyés (': 'Emails sent (',
  'Mode Auto ·': 'Auto mode ·',
  'Scanner Gmail': 'Scan Gmail',
  'Usinage': 'Machining',
  'actif': 'active',
  'actifs': 'active',
  "aujourd'hui": 'today',
  'commande': 'order',
  'jours actifs': 'active days',
  'offre': 'offer',
  'ouverts': 'open',
  'pays': 'countries',
  'projets': 'projects',
  'signalements ·': 'reports ·',
  'sous-traitant': 'subcontractor',
  "envoi(s) max possible(s) aujourd'hui": 'max possible send(s) today',
  'ticket(s) — feedback des sous-traitants pour les prochaines mises à jour': 'ticket(s) — subcontractor feedback for upcoming updates',
  '▲ masquer': '▲ hide',
  '▼ afficher': '▼ show',
  'Inscrit le': 'Registered on',
  'Boîte Gmail': 'Gmail inbox',
  'Agent IA — Démarchage': 'AI Agent — Prospecting',
  'Agent IA · Démarchage': 'AI Agent · Prospecting',
};

// Regex to detect pure dynamic data we should NEVER try to translate.
// (money, dates, numbers, IDs). The translator skips text matching these.
export const SKIP_PATTERNS = [
  /^\s*€?\s*[\d\s.,]+\s*€?\s*$/,          // money / numbers
  /^\s*\d{1,2}\/\d{1,2}\/\d{2,4}\s*$/,    // dates dd/mm/yyyy
  /^\s*\d{4}-\d{2}-\d{2}/,                // ISO dates
  /^\s*#?[A-Z0-9-]{4,}\s*$/,              // references/ids
  /^\s*[A-Za-zÀ-ÿ.\-' ]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\s*$/, // emails
];
